import { useEffect, useState } from "react";
import {
  getCart,
  addToCart,
  removeFromCart,
  updateCartQty,
  clearCart,
  saveCart,
} from "../../../utils/cart";

export const useCart = () => {
  const [cart, setCart] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setCart(getCart());
    setReady(true);
  }, []);

  const add = (product, qty = 1) => {
    const updated = addToCart(product, qty);
    setCart(updated);
  };

  const remove = (producto_id) => {
    const updated = removeFromCart(producto_id);
    setCart(updated);
  };

  const updateQty = (producto_id, cantidad) => {
    const updated = updateCartQty(producto_id, cantidad);
    setCart(updated);
  };

  const clear = () => {
    clearCart();
    setCart([]);
  };

  const totalItems = cart.reduce((sum, p) => sum + p.cantidad, 0);
  const subtotal = cart.reduce((sum, p) => sum + p.precio_unitario * p.cantidad, 0);
  const coreChargeTotal = cart.reduce(
    (sum, p) => sum + Number(p.core_charge || 0) * p.cantidad,
    0
  );
  const grandTotal = subtotal + coreChargeTotal;
  const replaceCart = (newCart) => {
    const normalized = newCart.map((item) => ({
      producto_id: item.producto_id,
      nombre: item.nombre ?? "",
      precio_unitario: Number(item.precio_unitario),
      precio_original: Number(item.precio_original ?? item.precio_unitario),
      en_oferta: Boolean(item.en_oferta),
      descuento_porcentaje: Number(item.descuento_porcentaje || 0),
      core_charge: Number(item.core_charge || 0),
      imagen: item.imagen,
      cantidad: item.cantidad,
      stock: item.stock,
    }));

    setCart(normalized);
    saveCart(normalized);
  };

  return {
    cart,
    ready,
    add,
    remove,
    updateQty,
    clear,
    totalItems,
    subtotal,
    coreChargeTotal,
    grandTotal,

    replaceCart,
  };
};
